import { createContext } from "react";

const WithdrawalScreen = createContext<any>(null);

export default WithdrawalScreen;
